import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2014Status: 'idle',
    startProcess2014Error: undefined as any,
    loadUserParamsProcess2014Status: 'idle',
    loadUserParamsProcess2014Error: undefined as any,

    process2014List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2014 = createAsyncThunk('process2014Slice/startProcess2014', async ({ process2014 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2014/`,
        prepareData(process2014),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2014Status } = getState().process2014Slice
        return startProcess2014Status !== 'pending'
    }
})

export const loadUserParamsProcess2014 = createAsyncThunk('process2014Slice/loadUserParamsProcess2014', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2014/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2014Status } = getState().process2014Slice
        return loadUserParamsProcess2014Status !== 'pending'
    }
})

const Process2014Slice = createSlice({
    name: 'process2014Slice',
    initialState,
    reducers: {
        resetstartProcess2014: (state) => {
            state.job = undefined
            state.startProcess2014Error = undefined
        },
        resetstartProcess2014Error: (state) => {
            state.startProcess2014Error = undefined
        },
        resetloadUserParamsProcess2014: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2014Error = undefined
        },
        resetloadUserParamsProcess2014Error: (state) => {
            state.loadUserParamsProcess2014Error = undefined
        },
        removeFromProcess2014ListById: (state, action) => {
            state.process2014List = state.process2014List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2014ListByIds: (state, action) => {
            state.process2014List = state.process2014List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2014List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2014Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2014List = []
            state.startProcess2014Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2014.pending, (state) => {
            state.startProcess2014Status = 'pending'
            state.startProcess2014Error = undefined
        })
        builder.addCase(startProcess2014.fulfilled, (state, action) => {
            state.startProcess2014Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2014.rejected, (state, action) => {
            state.startProcess2014Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2014Error = action.error.message
            } else {
                state.startProcess2014Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2014.pending, (state) => {
            state.loadUserParamsProcess2014Status = 'pending'
            state.loadUserParamsProcess2014Error = undefined
        })
        builder.addCase(loadUserParamsProcess2014.fulfilled, (state, action) => {
            state.loadUserParamsProcess2014Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2014.rejected, (state, action) => {
            state.loadUserParamsProcess2014Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2014Error = action.error.message
            } else {
                state.loadUserParamsProcess2014Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2014,
    resetstartProcess2014Error,
    resetloadUserParamsProcess2014,
    resetloadUserParamsProcess2014Error,
    removeFromProcess2014ListById,
    removeFromProcess2014ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2014Slice.actions
export default Process2014Slice.reducer
